import React from "react";
import { Toaster } from "react-hot-toast";
import "../../styles/toast-premium.css";

const PremiumToaster: React.FC = () => (
  <Toaster
    position="top-right"
    reverseOrder={false}
    gutter={10}
    containerClassName="premium-toaster"
    containerStyle={{
      zIndex: 10001,
    }}
    toastOptions={{
      duration: 3600,
      style: {
        background: "transparent",
        boxShadow: "none",
        padding: 0,
        border: "none",
      },
    }}
  />
);

export default PremiumToaster;
